import { useContext } from "react";

import { SmsLogContext } from "../contexts/SmsLogContext";
// import { AuthContext } from "../contexts/FirebaseAuthContext";
// import { AuthContext } from "../contexts/Auth0Context";
// import { AuthContext } from "../contexts/CognitoContext";

const useSms = () => {
  const context = useContext(SmsLogContext);

  if (!context) throw new Error("SmsLogConstants must be placed within SmsLogsProvider");

  return context;
};

export default useSms;
